import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "myicon-home",
  "use": "myicon-home-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol viewBox=\"0 0 16 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"myicon-home\"><path clip-rule=\"evenodd\" d=\"M0.707131 8.48527L1.7782 7.4142V13.0563V13.0564V14.0563H13.7782V13.0564V13.0563V7.4142L14.8493 8.48527L15.5564 7.77816L8.4853 0.707093L7.7782 -1.34706e-05L7.07109 0.707093L2.37823e-05 7.77816L0.707131 8.48527ZM2.7782 13.0563V6.4142L7.7782 1.4142L12.7782 6.4142V13.0563H9.7782V9.05637V8.05637H5.7782V9.05637V13.0563H2.7782ZM6.7782 9.05637V13.0563H8.7782V9.05637H6.7782Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol